import React, { useEffect } from 'react';
import { useHistory } from 'react-router';

const Main = () => {
  const history = useHistory();

  useEffect(() => {
    history.push('/pos');
  });

  return (
    <></>
  );
};

export default Main;
